module.exports = __webpack_public_path__ + "images/marketing/hero1.jpg";